<template>
    <div v-if="!isEmpty(activity_record_id)">
        <div class="header_box">
            <div class="info_line"><span class="b">活动名称：</span><span class="color_green0">{{activity_info.name}}</span></div>
            <div class="info_line"><span class="b">活动简介：</span>{{activity_info.desc}}</div>
            <div class="info_line"><span class="b">预约日期：</span>{{activity_record_info.order_date}}  {{activity_time_info.title}}</div>
            <div class="info_line"><span class="b">预约状态：</span>{{status_arr[activity_record_info.status]}}</div>
        </div>
        <div class="member_list">
            <template v-for="(one,index) in activity_member_list">
                <div class="box" :key="index">
                    <div class="info_line">
                        <div class="left">
                            <div class="info">{{one.realname}}<div class="blank_space space2"></div>{{member_sex_arr[one.sex]}}<div class="blank_space space2"></div>{{one.phone}}</div>
                            <div class="info">{{member_idtype_arr[one.idtype]}}：{{one.idcode}}</div>
                        </div>
                        <div class="right">
                            <div class="name">体温</div>
                            <div class="value" :class="{'color_red0':member_T_list[index].value >= error_T}" @click="openTSelect(index)">{{member_T_list[index].value}}</div>
                        </div>
                    </div>
                </div>
            </template>
        </div>
        <div class="bottom_btn">
            <div class="btn" @click="checkActivityRecord" v-if="activity_record_info.status == 0">确 认 入 园</div>
        </div>

        <van-popup v-model="T_select_show" position="bottom">
            <van-picker
                    show-toolbar
                    title="体温选择"
                    :columns="T_select_columns"
                    @cancel="closeTSelect"
                    @confirm="confirmTSelect"
            >
                <div slot="columns-top" class="T_select_title">
                    <div>整数位</div>
                    <div>小数位</div>
                </div>
            </van-picker>
        </van-popup>

        <van-popup v-model="check_success_show" :close-on-click-overlay="false">
            <div class="check_result">入园成功</div>
        </van-popup>
    </div>
</template>

<script>
    import mixins_reserve from '../../mixins/reserve'
    import * as api from "../../api/reserve";
    export default {
        name: "check"
        ,mixins: [mixins_reserve]
        ,data: function () {
            return {
                activity_record_id: null
                ,activity_info: {}
                ,activity_time_info: {}
                ,activity_record_info: {}
                ,activity_member_list: {}
                ,health_answer_arr: {}

                ,member_sex_arr: ['未知', '男', '女']
                ,member_idtype_arr: ['身份证','港澳通行证','台胞证','护照','军官证','士兵证']
                ,status_arr: ['已预约','已验票','已过期','已取消']

                ,member_T_index: 0
                ,member_T_list: []

                ,T_select_show: false
                ,T_select_columns: [
                    {
                        values: [34,35,36,37,38,39,40],
                        defaultIndex: 2
                    },
                    // 第二列
                    {
                        values: [0,1,2,3,4,5,6,7,8,9],
                        defaultIndex: 0
                    }
                ]

                ,error_T: 37.3

                ,check_success_show: false

            }
        }
        ,created: function() {
            this.getActivityInfo();
            this.getNowActivityRecord();
        }
        ,methods: {
            /**
             * 获得活动信息
             */
            getActivityInfo: function () {
                let that = this;

                api.getActivityInfo(that.activity_id).then(function (res) {
                    that.activity_info = res.data.activity_info;
                });
            }
            /**
             * 获取当前是否有预约记录
             */
            ,getNowActivityRecord: function () {
                let that = this;

                api.getNowActivityRecord(that.activity_id).then(function (res) {
                    that.activity_record_id = res.data.id;
                    that.getActivityRecordDetails();
                }).catch(function (res) {
                    that.$dialog.alert({
                        message: res.msg
                        ,className: 'color_red0'
                    });
                });
            }
            /**
             * 获取预约单详情
             */
            ,getActivityRecordDetails: function () {
                let that = this;

                api.getActivityRecordDetails(that.activity_record_id).then(function (res) {
                    that.activity_time_info = res.data.activity_time_info;
                    that.activity_member_list = res.data.activity_member_list;
                    that.health_answer_arr = res.data.health_answer_arr;
                    that.activity_record_info = res.data.activity_record_info;

                    for(let i in that.activity_member_list){
                        that.member_T_list.push({
                            id: that.activity_member_list[i]['id']
                            ,value: that.activity_member_list[i]['check_T']
                        });
                    }
                });
            }
            /**
             * 入园检测
             */
            ,checkActivityRecord: function () {
                let that = this;

                api.checkActivityRecord(that.activity_record_id, that.member_T_list).then(function () {
                    // that.$dialog.alert({
                    //     message: '入园成功'
                    //     ,showConfirmButton: false
                    // });
                    that.check_success_show = true;
                });
            }
            /**
             * 温度选择
             * @param index
             */
            ,openTSelect: function (index) {
                if(this.activity_record_info.status > 0) return false;

                this.member_T_index = index;
                if(!this.isEmpty(this.member_T_list[index].value)){
                    let t = this.member_T_list[index].value.split('.');
                    for(let i in t){
                        for(let ii in this.T_select_columns[i].values){
                            if(t[i] == this.T_select_columns[i].values[ii]){
                                this.T_select_columns[i].defaultIndex = parseInt(ii);
                            }
                        }
                    }
                }

                this.T_select_show = true;
            }
            ,closeTSelect: function () {
                this.T_select_show = false;
            }
            ,confirmTSelect: function (value0, value1) {
                this.member_T_list[this.member_T_index].value = value0[0] + '.' + value1[1];
                this.closeTSelect();
            }
        }
    }
</script>

<style lang="scss" scoped>
    .header_box{
        position: sticky;
        left: 0;
        top: 0;
        background-color: $color_bg_green0;
        padding: .28rem;
        box-shadow: $box_shadow_up;

        .info_line{
            font-size: .3rem;

            + .info_line{
                margin-top: .16rem;
            }
        }
    }
    .member_list{
        padding: .3rem .3rem .2rem .3rem;

        .box{
            border-radius: .12rem;
            background-color: $color_bg_grey0;
            box-shadow: $box_shadow_up;
            margin-bottom: .3rem;
            padding: .2rem;
            font-size: .3rem;

            .info_line{
                display: flex;
                justify-content: space-between;
                align-items: center;

                .left{

                    .tips{
                        color: $color_grey1;
                    }
                    .info{

                        + .info{
                            margin-top: .2rem;
                        }
                    }
                }
                .right{

                    .name{
                        font-weight: bold;
                        text-align: center;
                        margin-bottom: .2rem;
                    }
                    .value{
                        width: 1.2rem;
                        height: .6rem;
                        line-height: .6rem;
                        border-radius: .12rem;
                        border: .02rem solid $color_bdr_green0;
                        text-align: center;
                        font-size: .3rem;
                        font-weight: bold;
                        color: $color_green0;
                    }

                }
            }
        }
    }
    .bottom_btn{
        position: sticky;
        bottom: 0;
        left: 0;
        box-sizing: border-box;
        width: 100%;
        padding: .3rem;
        background-color: #fff;

        .btn{
            width: 100%;
            height: .88rem;
            line-height: .88rem;
            border-radius: .88rem;
            background-color: $color_bg_green1;
            text-align: center;
            color: #fff;
            font-size: .3rem;
        }
    }

    .T_select_title{
        display: flex;
        justify-content: center;
        align-items: center;

        >div{
            width: 50%;
            text-align: center;
            color: $color_grey2;
            font-size: .3rem;
        }
    }

    .check_result{
        box-sizing: border-box;
        width: 5.4rem;
        padding: .6rem .3rem;
        font-size: .48rem;
        font-weight: bold;
        text-align: center;
        color: $color_green0;
    }
</style>